import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {IShopUser} from "../../session/customer-models";
import {AddUpsellService} from "../../common/add-upsell.service";
import {Subscription} from "rxjs";
import {AnalyticsService} from "../../analytics/analytics.service";
import {take} from "rxjs/operators";
import {LoginModalService} from "../../login/login-modal.service";
import {Util} from "../../util/util";

@Component({
    selector: 'side-nav-account-switcher',
    templateUrl: './side-nav-account-switcher.component.html',
    styleUrls: ['./side-nav-account-switcher.component.scss'],
    standalone: false
})
export class SideNavAccountSwitcherComponent extends BaseComponent implements OnInit, OnDestroy {
    customerId: string;
    recognitionName: string;
    showPcUpsell: boolean = false;
    upsellSubscriptions: Subscription;
    path: string;
    position: string = 'side-nav-account-switcher';
    @Input() sponsorName: string;
    @Input() displaySponsorDetails: boolean = false;
    @Output() readonly closeSideMenu = new EventEmitter();


    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private loginModalService: LoginModalService,
        private addUpsellService: AddUpsellService,
        private analyticsService: AnalyticsService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.getCustomerData().then((user: IShopUser) => {
            this.customerId = this.authenticated ? user.customer.id.toString() : '';
            this.recognitionName = this.authenticated ? user.customer.recognitionName : '';
        });

        this.upsellSubscriptions = this.addUpsellService.addUpsellSubject.subscribe((value) => {
            if (!Util.isEmpty(value)) {
                this.showPcUpsell = value.pcUpsell;
            }
        });
    }

    ngOnDestroy() {
        this.upsellSubscriptions.unsubscribe();
    }

    switchAccounts(): void {
        this.closeSideMenu.emit();
        this.loginModalService.openLogin({isSwitchAccount: true}).pipe(take(1)).subscribe();
    }

    login(): void {
        this.closeSideMenu.emit();
        this.loginModalService.openLogin().pipe(take(1)).subscribe();
    }

    sendUpsellPromotionClick() {
        this.closeSideMenu.emit();
        this.analyticsService.upsellPromotionClickEvent( this.showPcUpsell, this.path, this.position);
    }
}
